import { Component, computed, input, output } from '@angular/core';
import { ProductListItem } from '@storybook/components/product-list/product-list.component';

const MAXIMUM_VISIBLE_PRODUCT_NAMES = 3;

@Component({
  selector: 'pdq-selected-products-summary',
  templateUrl: './selected-products-summary.component.html',
  styleUrls: ['./selected-products-summary.component.scss'],
  standalone: false,
})
export class SelectedProductsSummaryComponent {
  readonly selectedProducts = input<ProductListItem[]>([]);
  readonly selectionMode = input<'single' | 'multiple'>('multiple');
  readonly emptyMessage = input('No products selected');
  readonly invalid = input(false);

  readonly actionClick = output<void>();

  readonly singleSelectedProduct = computed(() =>
    this.selectionMode() === 'single' ? (this.selectedProducts()[0] ?? null) : null,
  );

  readonly selectedProductsCountLabel = computed(() => {
    const selectedProductsCount = this.selectedProducts().length;
    return `${selectedProductsCount} ${selectedProductsCount === 1 ? 'Product' : 'Products'} added`;
  });

  readonly selectedProductNamesSummary = computed(() => {
    const selectedProductNames = this.selectedProducts().map((product) =>
      product['variantTitle'] ? `${product.name} (${product['variantTitle']})` : product.name,
    );
    const visibleProductNames = selectedProductNames.slice(0, MAXIMUM_VISIBLE_PRODUCT_NAMES);
    const hiddenProductNamesCount = selectedProductNames.length - visibleProductNames.length;
    return hiddenProductNamesCount > 0
      ? `${visibleProductNames.join(', ')}, +${hiddenProductNamesCount}`
      : visibleProductNames.join(', ');
  });

  readonly actionLabel = computed(() => {
    if (!this.selectedProducts().length) {
      return 'Select';
    }
    return this.selectionMode() === 'single' ? 'Replace' : 'Edit';
  });
}
